/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Approve or dismiss queued messages: the ones named, or with all, every
 * message waiting for approval (or, for a failed one, try it again).
 */
export type QueueDecision = {
  decision: QueueDecision.decision;
  ids?: Array<number>;
  all?: boolean;
};

export namespace QueueDecision {
  export enum decision {
    APPROVE = "approve",
    DISMISS = "dismiss",
  }
}
